(function keyboardNavigationMode() {
  const root = document.documentElement;

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key === 'Tab') root.setAttribute('data-keyboard-navigation', '');
    },
    true
  );

  document.addEventListener('pointerdown', () => root.removeAttribute('data-keyboard-navigation'), true);
})();
